class AccordionItem extends HTMLElement {
  constructor() {
    super()

    this.el = this.querySelector('details')
    this.summary = this.el?.querySelector('summary')
    this.content = this.el?.querySelector('.content')

    this.animation = null
    this.isClosing = false
  }

  connectedCallback() {
    this.summary?.addEventListener('click', e => this.onClick(e))
  }

  onClick(e) {
    e?.preventDefault()
    this.el.style.overflow = 'hidden'
    if (this.isClosing || !this.el.open) {
      this.open()
    } else if (this.isExpanding || this.el.open) {
      this.shrink()
    }
  }

  close() {
    this.el.style.overflow = 'hidden'
    this.shrink()
  }

  shrink() {
    this.isClosing = true

    const startHeight = `${this.el.offsetHeight}px`
    const endHeight = `${this.summary.offsetHeight}px`

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 300,
        easing: 'ease-out',
      }
    )

    this.animation.onfinish = () => this.onAnimationFinish(false)
    this.animation.oncancel = () => (this.isClosing = false)
  }

  open() {
    const wrapper = this.closest('.js-items')
    wrapper?.querySelectorAll('accordion-item').forEach(item => item.close())

    this.el.style.height = `${this.el.offsetHeight}px`
    this.el.open = true
    this.dispatchOpenEvent()
    window.requestAnimationFrame(() => this.expand())
  }

  dispatchOpenEvent() {
    const accordionText = this.summary.textContent.trim()
    const eventData = { accordionText }

    if (this.hasAttribute('product-name')) {
      eventData.productName = this.getAttribute('product-name')
    }

    if (this.hasAttribute('product-sku')) {
      eventData.productSku = this.getAttribute('product-sku')
    }

    if (this.hasAttribute('product-price')) {
      eventData.productPrice = this.getAttribute('product-price')
    }

    document.dispatchEvent(
      new CustomEvent('accordion:open', {
        detail: eventData,
      })
    )
  }

  expand() {
    this.isExpanding = true
    const startHeight = `${this.el.offsetHeight}px`
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 300,
        easing: 'ease-out',
      }
    )
    this.animation.onfinish = () => this.onAnimationFinish(true)
    this.animation.oncancel = () => (this.isExpanding = false)
  }

  set isExpanding(value) {
    this._isExpanding = value
    this.classList.toggle('is-opening', value)
    this.classList.toggle('is-animating', value)
  }

  get isExpanding() {
    return this._isExpanding ?? false
  }

  set isClosing(value) {
    this._isClosing = value
    this.classList.toggle('is-closing', value)
    this.classList.toggle('is-animating', value)
  }

  get isClosing() {
    return this._isClosing ?? false
  }

  onAnimationFinish(open) {
    this.el.open = open
    this.animation = null
    this.isClosing = false
    this.isExpanding = false
    this.el.style.height = this.el.style.overflow = ''
  }
}

if (!customElements.get('accordion-item')) {
  customElements.define('accordion-item', AccordionItem)
}
